import { render, staticRenderFns } from "./role.vue?vue&type=template&id=79270b54"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79270b54')) {
      api.createRecord('79270b54', component.options)
    } else {
      api.reload('79270b54', component.options)
    }
    module.hot.accept("./role.vue?vue&type=template&id=79270b54", function () {
      api.rerender('79270b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/operation/role.vue"
export default component.exports